module.exports = __webpack_public_path__ + "media/pricing/digital-171167a0.jpg";